module.exports = __webpack_public_path__ + "img/sensor_w.c990effb.svg";